jQuery_T4NT(document).ready(function($) {

  /**
 *  Variant selection changed
 *  data-variant-toggle="{{variant.id}}"
 */
  // $( document ).on( "variant:changed", function( evt ) {
    // console.log( evt.currentVariant );
    // $('[data-variant-toggle]').hide(0);
    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  // });
 $( document ).on( "variant:changed", function( evt ) {
  // console.log( evt.currentVariant );
  const selectElem = document.querySelector(`.cartFusion_fbt_item select option[value="${evt.currentVariant.id}"]`);
  
  if (selectElem) {
    selectElem.selected = true;
    
    // Select element par 'change' event dispatch karein
    selectElem.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

  document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
    ele.addEventListener("input", function () {
      if (this.value < 0) {
          this.value = 0;
      }
    });
  });
  $(document).on("variant:changed", function (evt) {
    // console.log(evt.currentVariant.title);
    if (evt.currentVariant.title.includes('Customised')) {
        document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
            ele.removeAttribute("disabled");
        });
    } else {
        document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
            ele.setAttribute("disabled", "disabled");
        });
    };
  });


  // this script is not working
  // $( document ).on( "variant:changed", function( evt ) {
  //   // Select the option
  //   const option = document.querySelector(`.sr4-fbt__swatches li.sr4-fbt_item-0 select option[value='${evt.currentVariant.id}']`);
    
  //   if (option) {
  //     const selectElement = option.parentElement;
      
  //     // 1. Update the value
  //     option.selected = true;
  //     selectElement.value = evt.currentVariant.id;

  //     // 2. Dispatch the 'change' event so other listeners see the update
  //     selectElement.dispatchEvent(new Event('change', { bubbles: true }));
  //   }
  // });

  $(document).on("click", ".sr4-swatch__item", function () {

    const selectedShade = $(this).attr("data-value");

    if (!selectedShade) return;

    const fbtSelect = document.querySelector(".sr4-fbt__swatches li.sr4-fbt_item-0 select");

    if (!fbtSelect) return;

    const matchingOption = Array.from(fbtSelect.options).find(function (option) {
      return option.text.trim().toLowerCase() === selectedShade.trim().toLowerCase();
    });

    if (matchingOption) {
      fbtSelect.value = matchingOption.value;

      fbtSelect.dispatchEvent(new Event("change", { bubbles: true }));
      $(fbtSelect).trigger("change");
    }

  });

});